<template lang="html">

    <section class="wrapper legal">
      <div class="container">
  
        <h1>Aviso legal</h1>


        <h2>1.INFORMACIÓN LEGAL Y ACEPTACIÓN</h2>
<p>Estos términos legales regulan el uso del servicio de la página web www.launionhacelafuerza.es  propiedad de Innopulse asesores tecnológicos con cif B B84465863 y domicilio en  calle aguacate 29, 2-3, 28044 Madrid.</p>
<p>El acceso a la web de www.launionhacelafuerza.es es gratis salvo por el coste de uso de internet que cada usuario tenga contratado. Nuestra web es un canal de comunicación e información para los usuarios de internet. Todos los usuarios que acceden y navegan por nuestra web, aceptan y se vinculan con las condiciones que establecemos en estos términos Legales, además podríamos cambiarlos en cualquier momento; por lo que te recomendamos leerlos atentamente cada vez que lo visites.</p>
<h2>2. PROPIEDAD INTELECTUAL E INDUSTRIAL</h2>
<p>Todos los contenidos de esta web es decir, los textos, imágenes, vídeos, diseño gráfico, código fuente… y la marca, nombre comercial, logos y signos distintivos…, son propiedad industrial o intelectual de la unión hace la fuerza o de terceros. Así que salvo aquellos que resulten estrictamente necesarios para el uso de la web, ninguno de los contenidos de nuestra web puede entenderse cedido ni a ti ni a terceros, bajo ningún tipo de derecho de explotación.</p>
<h2>3. CONDICIONES DE USO</h2>
<p>Simplemente por visitar nuestra web no se entiende que establezcas ningún tipo de relación con La unión hace la fuerza . Debes usar nuestra página web de manera correcta, de acuerdo con la ley y estos términos legales. Responderás de cualquier daño y perjuicio que pudieras ocasionar en caso contrario, frente a la unión hace la fuerza o a terceros. Por ejemplo, queda prohibido que uses el portal tratando de sobrecargar las redes o nuestros servidores, o tratando de dañar cualquier equipo informático de la unión hace la fuerza o de terceros. Queda prohibido que copies, comuniques públicamente o transformes el contenido de nuestra página, salvo que la ley o la unión hace la fuerza te lo permitan.</p>
<p>Por último, si quieres enlazar desde cualquier sitio web a cualquier página de nuestra web, debes tener en cuenta que el enlace no podrá reproducir nuestra página ni siquiera parcialmente (o sea que no permitimos que se abran “iframes” que contengan ninguna parte de nuestra web), y que deberá siempre quedar claro la independencia y procedencia de los contenidos de la web.</p>
<h2>5. PROTECCIÓN DE DATOS PERSONALES</h2>
<p>Por favor consulta nuestra Política de Cookies.</p>
<h2>6. LEGISLACIÓN</h2>
<p>Estos términos legales se rigen por la ley española.</p>

  
     
  
  
  
      </div>
    </section>
  
  </template>
  
  <script lang="js">
    export default  {
      name: 'politica-de-privacidad',
  }
  </script>
  
  


// WEBPACK FOOTER //
// src/components/views/aviso-legal.vue